<template>
  <div>
    <ProductSearch class="mb-4" />
    <div class="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
      <CategoryCard
        v-for="category in parentCategories"
        :category="category"
        freeHeight
      />
    </div>
  </div>
</template>

<script>
import CategoryCard from "@/components/Categories/CategoryCard.vue";
import ProductSearch from "@/components/Products/ProductPage/ProductSearch.vue";

export default {
  name: "CategoryView",
  components: { ProductSearch, CategoryCard },
  computed: {
    parentCategories() {
      return this.$store.getters.categoryTree;
    },
    language() {
      return this.$route.query.lang || "en";
    },
  },
  mounted() {
    this.$store.dispatch("fetchCategories");
  },
};
</script>
